import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/information/raw.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6508bef8"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "content"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "Change Plan", -1);
});

var _hoisted_3 = {
  class: "detail"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "detail-raw"
  }, null, -1);
});

var _hoisted_5 = {
  class: "happend"
};
var _hoisted_6 = {
  class: "info"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "happend-title"
  }, "What happens next?", -1);
});

var _hoisted_8 = {
  class: "list"
};
var _hoisted_9 = {
  class: "item"
};

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "high-text"
  }, null, -1);
});

var _hoisted_11 = {
  class: "text"
};

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "item"
  }, [/*#__PURE__*/_createElementVNode("span", {
    class: "high-text"
  }), /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "The remainder of this month's bill will be refunded to your account within 5-10 business days.")], -1);
});

var _hoisted_13 = {
  class: "payment"
};

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "happend-title"
  }, "Payment", -1);
});

var _hoisted_15 = {
  class: "payment-content"
};
var _hoisted_16 = {
  class: "value"
};
var _hoisted_17 = {
  class: "update"
};

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", null, null, -1);
});

var _hoisted_19 = {
  class: "value"
};
var _hoisted_20 = {
  class: "date"
};
var _hoisted_21 = {
  class: "update-tip"
};

var _hoisted_22 = /*#__PURE__*/_createTextVNode(" To verify your payment method, we might charge you a small amount. We’ll refund the amount right away.");

var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("br", null, null, -1);
});

var _hoisted_24 = /*#__PURE__*/_createTextVNode(" You hereby authorise Riscern to charge you automatically every month until you cancel your subscription.");

var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("br", null, null, -1);
});

var _hoisted_26 = /*#__PURE__*/_createTextVNode(" Full terms are available ");

var _hoisted_27 = /*#__PURE__*/_createTextVNode(". ");

var _hoisted_28 = {
  class: "detail"
};

var _hoisted_29 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "detail-raw"
  }, null, -1);
});

var _hoisted_30 = {
  class: "happend"
};
var _hoisted_31 = {
  class: "info cancel"
};

var _hoisted_32 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "happend-title"
  }, "What happens next?", -1);
});

var _hoisted_33 = {
  class: "list"
};
var _hoisted_34 = {
  class: "item"
};

var _hoisted_35 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "high-text"
  }, null, -1);
});

var _hoisted_36 = {
  class: "text"
};

var _hoisted_37 = /*#__PURE__*/_createStaticVNode("<div class=\"item\" data-v-6508bef8><span class=\"high-text\" data-v-6508bef8></span><span class=\"text\" data-v-6508bef8>You can only verify up to 10 companies per day.</span></div><div class=\"item\" data-v-6508bef8><span class=\"high-text\" data-v-6508bef8></span><span class=\"text\" data-v-6508bef8>You won&#39;t be able to verify the company&#39;s shareholders, alerts, etc., only the registration information.</span></div><div class=\"item\" data-v-6508bef8><span class=\"high-text\" data-v-6508bef8></span><span class=\"text\" data-v-6508bef8>You won&#39;t be able to monitor the company.</span></div><div class=\"item\" data-v-6508bef8><span class=\"high-text\" data-v-6508bef8></span><span class=\"text\" data-v-6508bef8>You will lose report export functionality.</span></div>", 4);

var _hoisted_41 = {
  class: "btn"
};
var _hoisted_42 = {
  class: "price"
};

var _hoisted_43 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "subtotal"
  }, "Subtotal", -1);
});

var _hoisted_44 = /*#__PURE__*/_createTextVNode(" Change Plan ");

import { onMounted, ref } from 'vue';
import { apiUpgrade } from '@/api/information';
import { apiGetUpgradeInfo, apiSubscribe } from '@/api/common';
import { apiCancelSubscribe } from '@/api/company-info';
import { formatTime } from '@/utils/time';
import PageLoading from '@/components/pageLoading';
import { DATA_TYPE } from '@/utils/constData';
import Deep from './Deep.vue';
import Pro from './Pro.vue';
import Free from './Free.vue';
import { updateVisible, changePlanStatus } from '../../data';
import UpdateDialog from '../../UpdateDialog.vue';
import { ElMessage } from 'element-plus';
import { useRouter } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  props: {
    currentData: Object,
    initData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var router = useRouter();
    var currentData = ref({});
    var userCardData = ref({});
    var pageLoading = ref(true);
    var upGrateInfo = ref({});
    var termsDialogVisible = ref(false);

    function getInfo() {
      pageLoading.value = true;
      apiGetUpgradeInfo().then(function (_ref) {
        var data = _ref.data;
        currentData.value = data.subscribe || {};
        userCardData.value = data.userCard || {};
        upGrateInfo.value = data || {};
      }).finally(function () {
        pageLoading.value = false;
      });
    }

    function onClickUpdate() {
      updateVisible.value = true;
    }

    function onBack() {
      changePlanStatus.value = 0;
    }

    var changePlanBtnLoading = ref(false);
    var fullscreenLoading = ref(false);

    function getCurrentSubscribe(subscribeId, callBack) {
      apiSubscribe({
        subscribeId: subscribeId
      }).then(function (_ref2) {
        var data = _ref2.data;

        var _ref3 = data || {},
            subscribeStatus = _ref3.subscribeStatus,
            paymentStatus = _ref3.paymentStatus; // 订阅中 / 升级中


        if ([1, 5].includes(subscribeStatus)) {
          return callBack && callBack();
        } // 如果没有订阅信息 || 失败


        if (!paymentStatus) {
          return ElMessage.error('Credit card error: your credit card cannot be charged at this time. Please try again later.');
        } // 已订阅


        if ([2].includes(subscribeStatus)) {
          ElMessage.success('Change Plan successful');
          setTimeout(function () {
            callBack && callBack();
          }, 1000);
        } // 如果没有订阅信息 || 失败


        if (!subscribeStatus || [3].includes(subscribeStatus)) {
          ElMessage.error('Credit card error: your credit card cannot be charged at this time. Please try again later.');
        }
      });
    } // 升级订阅


    function handleChangePlan() {
      changePlanBtnLoading.value = true;
      var api = apiUpgrade;

      if (+changePlanStatus.value === 2) {
        api = apiCancelSubscribe;
      }

      api({
        subscribeId: currentData.value.id
      }).then(function (_ref4) {
        var data = _ref4.data;
        fullscreenLoading.value = true;
        setTimeout(function () {
          fullscreenLoading.value = false;

          if (+changePlanStatus.value === 2) {
            ElMessage.success('Change Plan successful');
            return router.push({
              name: 'InformationSubscriptions'
            });
          }

          getCurrentSubscribe(data.subscribeId, function () {
            return router.push({
              name: 'InformationSubscriptions'
            });
          });
        }, 3000);
      }).finally(function () {
        changePlanBtnLoading.value = false;
      });
    }

    onMounted(function () {
      getInfo();
    });
    return function (_ctx, _cache) {
      var _upGrateInfo$value, _userCardData$value, _userCardData$value2;

      var _component_el_button = _resolveComponent("el-button");

      var _component_termsInfoDialog = _resolveComponent("termsInfoDialog");

      var _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createVNode(_unref(PageLoading), null, null, 512), [[_directive_loading, fullscreenLoading.value, void 0, {
        fullscreen: true,
        lock: true
      }]]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, +_unref(changePlanStatus) === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_3, [_createVNode(Deep, {
        currentData: currentData.value,
        initData: __props.initData
      }, null, 8, ["currentData", "initData"]), _hoisted_4, _createVNode(Pro, {
        currentData: currentData.value,
        initData: __props.initData
      }, null, 8, ["currentData", "initData"])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("span", _hoisted_11, "Your new plan starts today, you will be charged $" + _toDisplayString(__props.initData.proPrice) + "/month.", 1)]), _hoisted_12])])]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, "Your next bill is for " + _toDisplayString(currentData.value && currentData.value.amount) + " USD on " + _toDisplayString(_unref(formatTime)((_upGrateInfo$value = upGrateInfo.value) === null || _upGrateInfo$value === void 0 ? void 0 : _upGrateInfo$value.nextPaymentDay)) + ".", 1), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", _hoisted_19, "Card ending in " + _toDisplayString((_userCardData$value = userCardData.value) === null || _userCardData$value === void 0 ? void 0 : _userCardData$value.cardNo), 1), _createElementVNode("div", _hoisted_20, [_createElementVNode("span", null, "Expires: " + _toDisplayString((_userCardData$value2 = userCardData.value) === null || _userCardData$value2 === void 0 ? void 0 : _userCardData$value2.expireDate), 1), _createElementVNode("div", {
        class: "high-text",
        onClick: onClickUpdate
      }, "Update")])])])])]), _createElementVNode("div", _hoisted_21, [_hoisted_22, _hoisted_23, _hoisted_24, _hoisted_25, _hoisted_26, _createElementVNode("span", {
        class: "high-text--pointer",
        onClick: _cache[0] || (_cache[0] = function () {
          return termsDialogVisible.value = true;
        })
      }, "here"), _hoisted_27])], 64)) : _createCommentVNode("", true), +_unref(changePlanStatus) === 2 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_28, [currentData.value.vipType === _unref(DATA_TYPE).DEEP ? (_openBlock(), _createBlock(Deep, {
        key: 0,
        currentData: currentData.value,
        initData: __props.initData
      }, null, 8, ["currentData", "initData"])) : _createCommentVNode("", true), currentData.value.vipType === _unref(DATA_TYPE).PRO ? (_openBlock(), _createBlock(Pro, {
        key: 1,
        currentData: currentData.value,
        initData: __props.initData
      }, null, 8, ["currentData", "initData"])) : _createCommentVNode("", true), _hoisted_29, _createVNode(Free, {
        currentData: currentData.value,
        initData: __props.initData
      }, null, 8, ["currentData", "initData"])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_hoisted_32, _createElementVNode("div", _hoisted_33, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_34, [_hoisted_35, _createElementVNode("span", _hoisted_36, "You'll change to our free plan on " + _toDisplayString(_unref(formatTime)(currentData.value.endTime)), 1)]), _hoisted_37])])])])], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [+_unref(changePlanStatus) === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_hoisted_43, _createElementVNode("span", null, "$" + _toDisplayString(__props.initData.proPrice), 1)], 64)) : _createCommentVNode("", true)]), _createElementVNode("div", {
        class: "go-back",
        onClick: onBack
      }, "Back"), _createVNode(_component_el_button, {
        type: "primary",
        class: "project-btn bottom-btn",
        onClick: handleChangePlan,
        loading: changePlanBtnLoading.value
      }, {
        default: _withCtx(function () {
          return [_hoisted_44];
        }),
        _: 1
      }, 8, ["loading"])]), _createVNode(UpdateDialog, {
        onGetData: getInfo
      }), _createVNode(_component_termsInfoDialog, {
        modelValue: termsDialogVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return termsDialogVisible.value = $event;
        })
      }, null, 8, ["modelValue"])])), [[_directive_loading, pageLoading.value]])], 64);
    };
  }
});